import * as React from 'react';
import { Row, DropdownButton, Dropdown, Col } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import '../custom.css';
import { useState, useEffect } from 'react';

import {msalApp} from "../auth-utils";
import SearchPopup from './Landing_Page/SearchPopup';
import { apiHelper } from './lib/ApiHelper';
import AuthProvider from '../AuthProvider';
import ImprintPopUp from './Landing_Page/ImprintPopUp';
import UserSetting from './Landing_Page/UserSetting';


function NavMenu(props) {
    const [user, setUser] = useState('XX');
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [openSettings, setOpenSettings] = useState(false);
    const [userName, setUserName] = useState('');
    const [searchActive, setSearchActive] = useState(false);
    const [VisualPermission, setVisualPermission] = useState(null);
    const [ImprintPopup, setImprintPopup] = useState(false);
    const onSignOut = () => {
        msalApp.logout();
    }
    const logo = "static/media/prh-logo-new.jpg";
    const getUserName = () => {
        const [firstName, lastName] = (props.username.includes(",")) ? props.username.split(',').map(name => name.trim()) : props.username.split(' ').map(name => name.trim());
        var userShortName = "";
        if (lastName && firstName) {
            userShortName = `${lastName.charAt(0)}${firstName.charAt(0)}`;
            setUserName(`${lastName} ${firstName}`);
            props.setUserInitials(userShortName);
        }
        else if (firstName) {
            userShortName = `${firstName.charAt(0)}`;
            setUserName(firstName);
        }
        setUser(userShortName);
    }
    const closeSearch = () => {
        setSearchActive(prev => !prev);
    }
   
    const refreshPage = async () => {
        try {
            let option = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'Authorization': `Bearer ${props?.BiToken}`
                },
            };
            const data = await fetch("https://api.powerbi.com/v1.0/myorg/groups/6ffb24e8-9cd6-45b9-bc11-57f35a6261f1/datasets/508d1abe-6a19-4d80-84cf-f042b10654d3/refreshes", option);
            console.debug(data);
        } catch (error) {
            console.error("refresh error", error);
        }
    }
  
    const handleToggle = (nextShow) => {
        setIsDropdownOpen(nextShow);
    };
    const toggleDropdown = () => setIsDropdownOpen(prev => !prev);

    const closeSetting = () => {
        setOpenSettings(false);
    }

    useEffect(() => {
        if (props.username && props.username != '') {
            getUserName();
        }
        // Returns the current URL minus the domain nam
    }, [props.username])

    const getVisualPermission = async () => {
      //  const visualPermission = await apiHelper.inventoryPostCall("getVisualPermission", { value: props?.upn });
     //   let data = await apiHelper.inventoryPostCall("getVisualPermission", { value: "agaonkar@penguinrandomhouse.com" });
        let data = await apiHelper.inventoryPostCall("getVisualPermission", { value: props?.upn });
        if (data != null && data.length > 0) {
            setVisualPermission(data[0]?.visualName);
        }
    }
    const handleClick = () => {
        setImprintPopup(prev => !prev);
    }
    useEffect(() => {
        /// call visual permission
        if (props?.upn != null && props?.upn != "") {
            getVisualPermission();
        }
    }, [props?.upn])

    return (
        <React.Fragment>
            <div className="app-header  mr-1 container-fluid">
                <div className="headerfit">
                    <img src={props.logo != "" ?props.logo : logo} className={props.audience === 'DK'? 'dk-header-logo' : 'header-logo'} alt="PRH Logo" />
                </div>
                <div className="headerBox">
                <div  className="header">
                    Inventory Hub
                </div>
                <div className="main-nav mr-2">                    
                    {props.audience != '' && <><NavLink to="/" className="headernav " key="dashboard" >DASHBOARD</NavLink>
                        <span className=" headernav pipe1" key="pipe1">|</span></>}
                    <NavLink to="/overview" className=" headernav" key="dashboard" >TITLE OVERVIEW</NavLink>
                    {props.audience != '' && <> <span className=" headernav pipe1" key="pipe2">|</span>
                            <NavLink to="/titleReport" className=" headernav" key="dashboard" >TITLE REPORT</NavLink></>}
                        {(VisualPermission === "ImprintMapping" && props.audience != '') && <> <span className=" headernav pipe1" key="pipe2">|</span>
                            <span className="imp-nav" key="dashboard" onClick={handleClick} style={{ cursor: "pointer" }}>OWNERSHIP ASSIGNMENTS</span></>}
                </div>
                </div>
                <div sm={2} className="main-nav">
                  
                     
                    <div className="d-inline" onClick={closeSearch}><i className="fas fa-search mr-1" /> </div>
                    <span onClick={toggleDropdown} style={{ cursor: "pointer" }}>
                    <div className="d-inline avtar ml-4 "  > {user}</div>
                    <div className="dropdown ml-1 d-inline black-color"><span>{ userName}</span>
                        <DropdownButton id="dropdown-example" className="d-inline" show={isDropdownOpen}      // Controlled visibility
                                onToggle={handleToggle}
                                onClick={toggleDropdown}
                                title=""                              >
                            <Dropdown.Item title="Accordian Settings" id="lnklogout" onClick={() => {
                                setOpenSettings(prev => !prev);
                                toggleDropdown();
                                }}><i className="fa fa-cog" aria-hidden="true"></i> &nbsp; &nbsp; User Settings</Dropdown.Item>
                                <Dropdown.Item title={props?.username ?? ''} id="lnklogout" onClick={() => { onSignOut(); toggleDropdown(); }}><i className="fa fa-sign-out" aria-hidden="true"></i> &nbsp; &nbsp; Log Out</Dropdown.Item>
                        
                            </DropdownButton>
                        </div> {/*<div className="helpButton d-inline">Help</div>
                        <DropdownButton id="dropdown-example" className="d-inline" disabled={true}>
                        </DropdownButton>*/}
                    </span>
                   
                    {searchActive ?
                        <SearchPopup
                            upn={props.upn}
                            onClose={closeSearch}
                            setIsbnData={props.setIsbnData}
                            isbnData={props.isbnData}
                        /> : <></>}

                    {ImprintPopup ?
                        <ImprintPopUp
                            upn={props.upn}
                            onClose={handleClick}
                            setIsbnData={props.setIsbnData}
                            isbnData={props.isbnData}
                        /> : <></>}

                    {openSettings && props?.audience != "" && props?.audience != null ?
                        <UserSetting
                            audience={props.audience}
                            upn={props.upn}
                            onClose={closeSetting}
                            setIsbnData={props.setIsbnData}
                            isbnData={props.isbnData}
                            setDKAccordSetting={props.setDKAccordSetting}
                            setUSAccordSetting={props.setUSAccordSetting}
                        /> : <></>}
                </div>
                
            </div>
           
        </React.Fragment>
    );

}
export default AuthProvider(NavMenu);
